import { shallowRef } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

const RESET_DELAY_MS = 500;

function getStorageItem(key) {
    if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key) || '';
    }

    return '';
}

function getApiKey() {
    return getStorageItem('token');
}

function getHashTeatro() {
    return store.getters.getConfig?.hash_teatro || getStorageItem('hash_teatro');
}

function buildReciboUrl(baseId) {
    const route = config.getAPIRoute('front.perfil.base.recibo');
    const url = route.url.replace('%base_id%', baseId);

    return `${config.API_BASE}${url}?api_key=${getApiKey()}&tid=${getHashTeatro()}`;
}

export function useReciboBase() {
    const downloadingBaseId = shallowRef(null);
    const error = shallowRef('');

    function clearDownloadingState() {
        window.setTimeout(() => {
            downloadingBaseId.value = null;
        }, RESET_DELAY_MS);
    }

    function downloadRecibo(baseId) {
        downloadingBaseId.value = baseId;
        error.value = '';

        try {
            window.open(buildReciboUrl(baseId), '_blank');
        } catch (downloadError) {
            error.value = downloadError?.message || 'Error al descargar el recibo';
        } finally {
            clearDownloadingState();
        }
    }

    return {
        downloadingBaseId,
        error,
        downloadRecibo
    };
}
